"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./Alert.scss");
var AlertProps_1 = require("./AlertProps");
var Alert = function (_a) {
    var children = _a.children, className = _a.className, closeable = _a.closeable, _b = _a.type, type = _b === void 0 ? AlertProps_1.defaultType : _b, _c = _a.icon, icon = _c === void 0 ? type && AlertProps_1.TypeIcon[type] : _c, _d = _a.hideSideBordersOnMobile, hideSideBordersOnMobile = _d === void 0 ? true : _d, name = _a.name, onClose = _a.onClose, _e = _a.onWhite, onWhite = _e === void 0 ? false : _e, testId = _a.testId;
    var _f = __read(React.useState({
        closed: false,
        render: true,
    }), 2), state = _f[0], setState = _f[1];
    var render = state.render;
    var alertElement = React.useRef(null);
    var close = React.useCallback(function () {
        setState(__assign(__assign({}, state), { closed: true }));
        setState(__assign(__assign({}, state), { render: false }));
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }, [onClose]);
    var classes = [
        styles.alert,
        "flex",
        "flex-items-top",
        "bg-ui-white pad-l-sm-lg pad-t-sm-lg pad-b-sm-lg pad-r-md-lg pad-t-xs-sm pad-b-xs-sm ",
        "rel",
        className,
    ];
    if (onWhite) {
        classes.push(styles.onWhite + " border-shadow");
    }
    if (hideSideBordersOnMobile) {
        classes.push(styles.hideSides);
    }
    return render ? (React.createElement("div", { className: "globalv1" },
        React.createElement("div", { className: classes.join(" "), "data-testid": testId, ref: alertElement },
            React.createElement("div", { className: "width-md-lg height-md-lg width-lg-md height-lg-md width-lg-sm height-lg-sm mar-r-xxs mar-r-none-sm " + styles.padBxxxxS + " pad-r-xxxs pad-none-sm mar-t-none-sm " + styles.flexShrink }, icon),
            React.createElement("div", { className: "type-base line-h-md color-ui-dark-gray mar-b-none mar-t-none-sm rel " + styles.padTxxxxSSm + " mar-l-xxxs mar-l-xxs-sm mar-t-xxxs" }, children),
            closeable && (React.createElement("button", { "aria-label": "Close " + (name || "alert"), name: "Close_" + (name || "alert"), className: styles.positionClose + " icon-close absolute color-ui-black", onClick: close }))))) : null;
};
exports.default = Alert;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Alert/Alert.js
// module id = 655
// module chunks = 8